/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { InputChip } from 'components/Fields';

const HeelColor = () => (
  <InputChip type="HEEL_COLOR" name="HeelColor" label="Heel color" />
);

export default HeelColor;
